module.exports = __webpack_public_path__ + "static/media/facebook.c00b03b2.svg";